import React, {useState} from 'react';
import {fetchApi} from './utils/fetch';
import {parseEmailList} from './utils/emailList';

// Coach emails on a live survey (#621, D2). Editable after invites go out; a
// change applies to completions after it, and earlier completions reach the
// coach only through Send Results.
export default function CoachEmailsEditor({survey, onSaved}) {
  const [value, setValue] = useState((survey.coach_emails || []).join(', '));
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);

  function save(event) {
    event.preventDefault();
    setSaving(true);
    setError(null);

    fetchApi(`/api/v1/internal/surveys/${survey.id}`, {
      method: 'PATCH',
      body: JSON.stringify({survey: {coach_emails: parseEmailList(value)}}),
    })
      .then((response) => {
        if (response?.success) {
          onSaved?.();
        } else {
          setError(response?.error || 'The coach emails could not be saved.');
        }
      })
      .finally(() => setSaving(false));
  }

  return (
    <form onSubmit={save} className="mt-2">
      <label htmlFor="survey_coach_emails" className="block text-sm font-medium text-gray-700">Coach emails</label>
      <div className="mt-1 flex items-center space-x-2">
        <input
          id="survey_coach_emails"
          type="text"
          value={value}
          onChange={({target}) => setValue(target.value)}
          placeholder="coach@example.com"
          className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
        />
        <button
          type="submit"
          disabled={saving}
          aria-label="Save coach emails"
          className="inline-flex items-center rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50"
        >
          Save
        </button>
      </div>
      <p className="mt-1 text-sm text-gray-500">
        Each address gets a copy of every participant's results PDF. Changes apply to completions from now on; earlier completions reach a coach only through Send Results. Completions from before delivery tracking began that already had a results PDF never reach a coach.
      </p>
      {error && <p role="alert" className="mt-1 text-sm text-red-600">{error}</p>}
    </form>
  );
}
